import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WsbFrontendComponent } from './views/wsb-frontend/wsb-frontend.component';
import { UserRouteAccessService } from './core/auth/user-route-access-service';
import { LoginComponent } from './views/login/login.component';
import { RegisterComponent } from './views/register/register.component';
import { SubaccountStatisticsComponent } from './views/reseller/subaccount-statistics/subaccount-statistics.component';
import { ResellerHistoryComponent } from './views/reseller/reseller-history/reseller-history.component';
import { PartnerAnalyticsComponent } from './views/partner/analytics/partner-analytics.component';
import { PartnerClientSetupComponent } from './views/partner/client-setup/partner-clientsetup.component';
import { RichSmsDetailsComponent } from '@modules/statistics/rich-sms-details/rich-sms-details.component';
import { SmsHistoryComponent } from './views/sms/sms-history/sms-history.component';
import { EmailCampaignsSettingsComponent } from './views/email/settings/email-campaigns-settings.component';
import { EmailCampaignSetupComponent } from './views/email/settings/tab-list/setup-list/email-campaigns-setup.component';
import { LandingStatsComponent } from './views/pages/landing-stats/landing-stats/landing-stats.component';
import { EmailListComponent } from './views/email/email-list/email-history.component';
import { EmailStatsComponent } from './views/email/email-list/email-stats/email-stats.component';
import { SmsadvComponent } from './views/smsadv/smsadv.component';
import { EmailCreateComponent } from './views/email/email-create/email-create.component';
import { PartnerPaymentsComponent } from './views/partner/payments/partner-payments.component';
import { SmsAdvCreateComponent } from './views/smsadv/sms-adv-create/sms-adv-create.component';
import { SmsAdvListComponent } from './views/smsadv/sms-adv-list/sms-adv-list.component';
import { RedirectBackFromEditorComponent } from './views/email/email-create/redirect-back-from-editor/redirect-back-from-editor.component';
import { TemplateComponent } from './views/email/template/template.component';
import { PartnerDashboardComponent } from './views/partner/partner-dashboard.component';
import { ProfileManageComponent } from './views/profile/profile-manage/profile-manage.component';
import { ResellerPriceEditComponent } from './views/reseller/price-edit/reseller-price-edit.component';
import { ResellerPriceComponent } from './views/reseller/price/reseller-price.component';
import { ResellerProfileComponent } from './views/reseller/profile/reseller-profile.component';
import { ResellerProfilesComponent } from './views/reseller/profiles/reseller-profiles.component';
import { ResellerSendersComponent } from './views/reseller/senders/reseller-senders.component';
import { SubaccountDetailComponent } from './views/reseller/subaccount-detail/subaccount-detail.component';
import { ResellerSubaccountHistoryComponent } from './views/reseller/subaccount-history/reseller-subaccount-history.component';
import { SubaccountManageComponent } from './views/reseller/subaccount-manage/subaccount-manage.component';
import { SuperaccountSettingsComponent } from './views/reseller/subaccount-settings/superaccount-settings.component';
import { ChangeEmailComponent } from './views/reset/change-email/change-email.component';
import { ResetPasswordComponent } from './views/reset/reset-password/reset-password.component';
import { ResetProfileComponent } from './views/reset/reset-profile/reset-profile.component';
import { CartBillingComponent } from './views/shop/cart-billing/cart-billing.component';
import { ShopCartComponent } from './views/shop/shop-cart/shop-cart.component';
import { ShopPurchaseErrorComponent } from './views/shop/shop-purchase-error/shop-purchase-error.component';
import { ShopPurchaseSuccessComponent } from './views/shop/shop-purchase-success/shop-purchase-success.component';
import { SmsSendersComponent } from './views/sms/senders/senders.component';
import { StudioComponent } from './views/studio/studio.component';
// import { ComposeLandingComponent } from './views/pages/editor-landing/compose-landing/compose-landing.component';
import { ComposeEmailEditorComponent } from './views/email/editor-email/compose-email-editor/compose-email-editor.component';
import { BillingComponent } from './views/billing/billing.component';
import { RouteInactivePageService } from './core/auth/route-inactive-page.service';
import { auth0LoginService } from './core/auth/auth0-login.service';

const appRoutes: Routes = [
  { path: 'login', component: LoginComponent, canActivate: [auth0LoginService] },
  { path: 'loginfastsms', component: LoginComponent },
  { path: 'register', component: RegisterComponent, canActivate: [RouteInactivePageService] },
  { path: 'reset/profile', component: ResetProfileComponent },
  { path: 'reset/password', component: ResetPasswordComponent },
  { path: 'reset/email', component: ChangeEmailComponent },
  { path: 's/user/password', component: ResetPasswordComponent },
  { path: 's/user/email', component: ChangeEmailComponent },
  {
    path: 'account',
    canActivate: [UserRouteAccessService],
    loadChildren: () => import('./views/account/account.module').then(m => m.AccountModule)
  },
  {
    path: 'profile',
    canActivate: [UserRouteAccessService],
    loadChildren: () => import('./views/profile/profile.module').then(m => m.ProfileModule)
  },
  { path: 'profile/manage', component: ProfileManageComponent, canActivate: [UserRouteAccessService] },
  { path: 'billing', component: BillingComponent, canActivate: [UserRouteAccessService] },

  {
    path: 'dashboard',
    canActivate: [UserRouteAccessService],
    loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
  },

  {
    path: 'support',
    canActivate: [UserRouteAccessService],
    loadChildren: () => import('./views/support/support.module').then(m => m.SupportModule)
  },

  {
    path: 'contacts',
    canActivate: [UserRouteAccessService],
    loadChildren: () => import('./views/contacts/contacts.module').then(m => m.ContactsModule)
  },

  { path: 'reseller/profiles', component: ResellerProfilesComponent, canActivate: [UserRouteAccessService] },
  { path: 'reseller/profile/create', component: ResellerProfileComponent, canActivate: [UserRouteAccessService] },
  { path: 'reseller/profile/:id', component: ResellerProfileComponent, canActivate: [UserRouteAccessService] },
  { path: 'reseller/subaccounts-create', component: SubaccountDetailComponent, canActivate: [UserRouteAccessService] },
  { path: 'reseller/subaccounts-settings', component: SubaccountDetailComponent, canActivate: [UserRouteAccessService] },
  { path: 'reseller/subaccounts', component: SubaccountManageComponent, canActivate: [UserRouteAccessService] },
  { path: 'reseller/history', component: ResellerHistoryComponent, canActivate: [UserRouteAccessService] },
  { path: 'reseller/subaccounts-history', component: ResellerSubaccountHistoryComponent, canActivate: [UserRouteAccessService] },
  { path: 'reseller/settings', component: SuperaccountSettingsComponent, canActivate: [UserRouteAccessService] },
  { path: 'reseller/senders', component: ResellerSendersComponent, canActivate: [UserRouteAccessService] },
  { path: 'reseller/prices', component: ResellerPriceComponent, canActivate: [UserRouteAccessService] },
  { path: 'reseller/prices/edit', component: ResellerPriceEditComponent, canActivate: [UserRouteAccessService] },
  { path: 'reseller/prices/edit/:id', component: ResellerPriceEditComponent, canActivate: [UserRouteAccessService] },
  { path: 'reseller/stats', component: SubaccountStatisticsComponent, canActivate: [UserRouteAccessService] },
  { path: 'partner/dashboard', component: PartnerDashboardComponent, canActivate: [UserRouteAccessService] },
  { path: 'partner/setup', component: PartnerClientSetupComponent, canActivate: [UserRouteAccessService] },
  { path: 'partner/analytics', component: PartnerAnalyticsComponent, canActivate: [UserRouteAccessService] },
  { path: 'sms/senders', component: SmsSendersComponent, canActivate: [UserRouteAccessService] },
  { path: 'sms/campaigns', component: SmsHistoryComponent, canActivate: [UserRouteAccessService] },
  { path: 'shop/purchase-error', component: ShopPurchaseErrorComponent, canActivate: [UserRouteAccessService] },
  { path: 'shop/purchase-success', component: ShopPurchaseSuccessComponent, canActivate: [UserRouteAccessService] },
  {
    path: 'shop/index',
    canActivate: [UserRouteAccessService],
    loadChildren: () => import('./views/shop/shop-index/shop-index.module').then(m => m.ShopIndexModule)
  },
  { path: 'shop/cart-billing', component: CartBillingComponent, canActivate: [UserRouteAccessService] },
  { path: 'shop/cart', component: ShopCartComponent, canActivate: [UserRouteAccessService] },
  { path: 'shop/cart-summary', component: ShopCartComponent, canActivate: [UserRouteAccessService] },
  {
    path: 'pages',
    canActivate: [UserRouteAccessService],
    loadChildren: () => import('./views/pages/pages.module').then(m => m.PagesModules)
  },

  // { path: 'pages/templates', component: TemplatesComponent, canActivate: [UserRouteAccessService] },
  // { path: 'pages/list_domains', component: ListDomainsComponent, canActivate: [UserRouteAccessService] },
  // { path: 'pages/create', component: CreateComponent, canActivate: [UserRouteAccessService] },
  // { path: 'pages/settings', component: SettingsComponent, canActivate: [UserRouteAccessService] },
  // { path: 'pages/list', component: PagesListComponent, canActivate: [UserRouteAccessService] },
  // { path: 'pages/data/:id', component: PagesListFormDataComponent, canActivate: [UserRouteAccessService] },
  { path: 'stats/pages', component: LandingStatsComponent, canActivate: [UserRouteAccessService] },
  { path: 'studio', component: StudioComponent, canActivate: [UserRouteAccessService] },
  { path: 'mail/templates', component: TemplateComponent, canActivate: [UserRouteAccessService] },
  { path: 'stats/richsms-detail', component: RichSmsDetailsComponent, canActivate: [UserRouteAccessService] },
  { path: 'mail/list', component: EmailListComponent, canActivate: [UserRouteAccessService] },
  { path: 'mail/campaigns', component: EmailCampaignsSettingsComponent, canActivate: [UserRouteAccessService] },
  { path: 'mail/campaign-setup', component: EmailCampaignSetupComponent, canActivate: [UserRouteAccessService] },
  { path: 'mail/campaign-setup/:id', component: EmailCampaignSetupComponent, canActivate: [UserRouteAccessService] },
  { path: 'mail/stats/:id', component: EmailStatsComponent, canActivate: [UserRouteAccessService] },
  { path: 'bdd', component: SmsadvComponent, canActivate: [UserRouteAccessService] },
  { path: 'mail/send', component: EmailCreateComponent, canActivate: [UserRouteAccessService] },
  { path: 'partner/payout', component: PartnerPaymentsComponent, canActivate: [UserRouteAccessService] },
  { path: 'mail/choose-recipients', redirectTo: 'mail/send', pathMatch: 'full' },
  { path: 'mail/edit', component: RedirectBackFromEditorComponent, canActivate: [UserRouteAccessService] },
  { path: 'smsadv/campaigns', component: SmsAdvListComponent, canActivate: [UserRouteAccessService] },
  { path: 'smsadv/create', component: SmsAdvCreateComponent, canActivate: [UserRouteAccessService] },
  // { path: 'pages/compose', component: ComposeLandingComponent, canActivate: [UserRouteAccessService] },
  { path: 'mail/mail-editor', component: ComposeEmailEditorComponent, canActivate: [UserRouteAccessService] },
  {
    path: 'stats',
    canActivate: [UserRouteAccessService],
    loadChildren: () => import('@modules/statistics/statistics.module').then(m => m.StatisticsModule)
  },
  {
    path: 'sms',
    canActivate: [UserRouteAccessService],
    loadChildren: () => import('@modules/sms/sms.module').then(m => m.SmsModule)
  },
  {
    path: 'smsin',
    canActivate: [UserRouteAccessService],
    loadChildren: () => import('@modules/smsin-statistics/smsin.module').then(m => m.SmsinModule)
  },
  { path: 'shop', redirectTo: '/shop/index', pathMatch: 'full' },
  { path: 'dashboard/welcome', redirectTo: '/dashboard', pathMatch: 'prefix' },
  { path: 'contacts/blacklist', redirectTo: '/contacts/blocklist', pathMatch: 'prefix' },
  // { path: 'edit_admin', redirectTo: '/billing', pathMatch: 'prefix' },
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: '**', component: WsbFrontendComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
